import * as React from 'react';
import './mud.css';

const HowToPlay = () => (
  <div className="lots-shell">
    <div className="lots-container">
      <div className="lots-hero">
        <div className="portal-kicker">Onboarding</div>
        <h1 className="lots-hero__title">How to Play</h1>
        <p className="lots-hero__subtitle">
          Legacy of the Sith is a living Star Wars MUD. The fastest way to learn is to play, but this guide
          will get you moving with confidence.
        </p>
        <div className="portal-cta-row">
          <a className="lots-btn" href="/mud">Play Online (alpha)</a>
          <a className="lots-btn lots-btn--ghost" href="/character/new">Create Character</a>
        </div>
      </div>

      <div className="lots-grid lots-grid--two">
        <div className="lots-card lots-card--accent">
          <h3>What is a MUD?</h3>
          <p>
            A MUD (Multi-User Dungeon) is a classic text-based multiplayer RPG. Commands drive everything, from
            movement to combat to social roleplay. The web client is experimental, and the best experience still
            comes from a dedicated MUD client.
          </p>
        </div>
        <div className="lots-card">
          <h3>Recommended Clients</h3>
          <p>
            <a href="https://www.mudlet.org/" target="_blank" rel="noreferrer">Mudlet</a>
            {' '}or{' '}
            <a href="https://www.mushclient.com/" target="_blank" rel="noreferrer">MUSHclient</a>
            {' '}are the most stable options.
          </p>
          <div className="portal-note">Use them for triggers, aliases, and richer text rendering.</div>
        </div>
      </div>

      <div className="lots-grid lots-grid--three" style={{ marginTop: '1.5rem' }}>
        <div className="lots-card">
          <div className="portal-kicker">Quick Setup</div>
          <h4>Connect in 60 seconds</h4>
          <p>Address: <strong>legacyofthesith.com</strong></p>
          <p>Port: <strong>3000</strong></p>
          <p>Create your character in-game, or use the web creator first.</p>
        </div>
        <div className="lots-card">
          <div className="portal-kicker">First Commands</div>
          <h4>Learn the basics</h4>
          <p><span className="portal-chip">look</span> <span className="portal-chip">who</span> <span className="portal-chip">score</span></p>
          <p>Type commands and press Enter. Use <strong>help</strong> to explore command lists.</p>
        </div>
        <div className="lots-card">
          <div className="portal-kicker">Get Oriented</div>
          <h4>New to LotS</h4>
          <p>Join OOC chat, ask for a mentor, and pick a faction path early.</p>
          <a className="lots-btn lots-btn--ghost" href="/player#ooc">Open OOC Chat</a>
        </div>
      </div>
    </div>
  </div>
);

export default HowToPlay;
